import clsx from 'clsx';

import {Figure} from '@/components/figure';
import {ImageBlock} from '@/components/image/ImageBlock';
import type {ImageWeb} from '@/components/image/types';

interface Props {
	image: ImageWeb | null;
}

const classNameOverride = {
	figure: 'my-6',
};

export const PortableImage = ({image}: Props) => {
	if (!image) {
		return null;
	}

	return (
		<div className={clsx('my-10')}>
			{image.caption || image.credit ? (
				<Figure
					credit={image.credit}
					caption={image.caption}
					classNameOverride={classNameOverride}
				>
					<ImageBlock
						height={image.image.height}
						src={image.image.src}
						width={image.image.width}
						alt={image.altText ?? ''}
						className={clsx('rounded-xl')}
					/>
				</Figure>
			) : (
				<ImageBlock
					height={image.image.height}
					src={image.image.src}
					width={image.image.width}
					alt={image.altText ?? ''}
					className={clsx('rounded-xl')}
				/>
			)}
		</div>
	);
};
